import Swiper, { Navigation } from 'swiper';

export default class Slider {
	constructor(sliderElement) {

        const parentContainer = sliderElement.closest('.modal__content');
        const nextButton = parentContainer.querySelector('.swiper-button-next');
        const prevButton = parentContainer.querySelector('.swiper-button-prev');

        this.numberSlides = parentContainer.querySelector('[data-number-slides]');

        const options = {
            direction: 'horizontal',
            slidesPerView: 1,
            centeredSlides: true,
            lazy: true,
            speed: 1000,
            keyboard: true,
            modules: [Navigation],
            runCallbacksOnInit: true,

            on: {
                init: (swiper) => this.setNumberOfSlides(swiper),
                slideChange: (swiper) => this.setNumberOfSlides(swiper),
                slidesLengthChange: (swiper) => this.setNumberOfSlides(swiper),
            },

            a11y: {
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
            },

            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
        };

        this.swiper = new Swiper(sliderElement, options);
	}

    setNumberOfSlides(swiper) {
        this.numberSlides.innerHTML = (swiper.activeIndex +  1) + '/' + swiper.slides.length;
    }
}
